import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Snackbar } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useTranslation } from "react-i18next";
import { PortDetailsDto } from "~/api/GeneratedApi";

const useStyles = makeStyles((theme) => ({
  icon: {
    fill: theme.palette.primary.contrastText,
  },
  focusButton: {
    color: theme.palette.common.white,
  },
}));

interface Props {
  port?: PortDetailsDto;
  onClose: () => void;
  viewChanged: boolean;
  refocus: (port?: PortDetailsDto) => void;
}

const PortFocusBar = ({
  port,
  onClose,
  viewChanged,
  refocus,
}: Props): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation("port");
  return (
    <Snackbar
      open={!!port}
      message={port?.name}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ zIndex: (theme) => theme.zIndex.speedDial }}
      action={
        <>
          {viewChanged && (
            <Button
              onClick={() => refocus(port)}
              classes={{ root: classes.focusButton }}
            >
              {t("center")}
            </Button>
          )}
          <IconButton onClick={onClose} size="large">
            <CloseIcon className={classes.icon} />
          </IconButton>
        </>
      }
    />
  );
};

export default PortFocusBar;
